import React from 'react';
import './component3.css';

const Component3 = ({ title, text }) => (
  <div className="component3-container__feature">
    <div className="component3-container__feature-title">
      <div />
      <h1>{title}</h1>
    </div>
    <div className="component3-container_feature-text">
      <p>{text}</p>
    </div>
  </div>
);

export default Component3